import { NotificationManager } from "react-notifications";
import { Actions as INTEGRATION_ACTIONS } from "@/redux/actions/integrationActions";

import cleanDeep from "clean-deep";
import { createRequest, checkExecutionStatus as checkStepFunctionStatus } from "@/helpers/RequestHelpers";
import { camelCase } from "lodash";
import apiURL, { domain } from "@/redux/actions/apiURL";
import { constructQueryParams, toTitleCase } from "@/common/validation/Validators";

const MOCK_INTEGRATION = window.localStorage.getItem("MOCK_NEST_INTEGRATION") && ["local", "review"].includes(domain);
const LOG_MOCK = window.localStorage.getItem("LOG_MOCK");

const mockIntegration = ({ path, method, query }) => {
	const mock = method + path + constructQueryParams(query);
	if (LOG_MOCK) NotificationManager.info(`Mocking ${mock}`, "Mocking");

	return new Promise((resolve, reject) => {
		const mockObject = {
			"GET/nest/schemes": {
				poll: {
					id: "9a9cab95-ab95-58af-b525-df48dab294f4",
					status: "pending", // pending, response, success, error, timed out
					action: "Import Schemes & Groups",
					nextPollAt: "2021-09-01T00:00:00.000Z",
					expectedCompletionTime: "2021-09-01T00:00:00.000Z",
				},
			},
			"GET/nest/polls/9a9cab95-ab95-58af-b525-df48dab294f4": {
				id: "9a9cab95-ab95-58af-b525-df48dab294f4",
				status: "response", // pending, response, success, error, timed out
				action: "Import Schemes & Groups",
				completedAt: "2021-09-01T00:00:00.000Z",
				schemes: [
					{
						name: "NEST Scheme",
						schemeType: "unbanded",
						startDate: "2021-09-01",
						endDate: "null",
					},
				],
				groups: [
					{
						name: "Group 1",
						startDate: "2021-09-01",
						endDate: "null",
						employeeContribution: 5,
						employeePercentage: true,
						employerContribution: 5,
						employerPercentage: true,
					},
					{
						name: "Directors",
						startDate: "2021-09-01",
						endDate: "null",
						employeeContribution: 0,
						employeePercentage: false,
						employerContribution: 1000,
						employerPercentage: false,
					},
				],
				expectedCompletionTime: "2021-09-01T00:00:00.000Z",
			},
			"GET/nest/polls": [
				{
					id: "8274157e-40a1-5d57-9796-7527a88979c2",
					status: "pending",
					action: "Import Pay Periods",
					nextPollAt: "2021-09-01T00:00:00.000Z",
					expectedCompletionTime: "2021-09-01T00:00:00.000Z",
				},
				{
					id: "39c58f0f-28df-522d-9545-e759c928ba20",
					status: "pending",
					action: "Send Contributions",
					payPeriodId: "payPeriodId",
					nextPollAt: "2021-09-01T00:00:00.000Z",
					expectedCompletionTime: "2021-09-01T00:00:00.000Z",
					payPeriodId: "ea4422cb-e260-43e4-b137-c593ba8f4386",
				},
				{
					id: "39c58f0f-28df-522d-9545-e759c928ba21",
					status: "pending",
					action: "Approve Contributions",
					payPeriodId: "payPeriodId",
					nextPollAt: "2021-09-01T00:00:00.000Z",
					expectedCompletionTime: "2021-09-01T00:00:00.000Z",
					payPeriodId: "ea4422cb-e260-43e4-b137-c593ba8f4386",
				},
			],
			"GET/nest/polls/8274157e-40a1-5d57-9796-7527a88979c2": {
				id: "8274157e-40a1-5d57-9796-7527a88979c2",
				status: "error",
				payPeriods: [
					{
						paySchedule: "Monthly",
						periodStart: "2021-09-01",
						periodEnd: "2021-09-15",
					},
				],
				errors: [
					{
						message: "Could not find pay schedule",
					},
				],
				action: "Import Pay Periods",
				nextPollAt: "2021-09-01T00:00:00.000Z",
				expectedCompletionTime: "2021-09-01T00:00:00.000Z",
			},
			"GET/nest/polls/39c58f0f-28df-522d-9545-e759c928ba20": {
				id: "39c58f0f-28df-522d-9545-e759c928ba20",
				status: "pending",
				action: "Send Contributions",
				payPeriodId: "payPeriodId",
				nextPollAt: "2021-09-01T00:00:00.000Z",
				expectedCompletionTime: "2021-09-01T00:00:00.000Z",
				payPeriodId: "ea4422cb-e260-43e4-b137-c593ba8f4386",
			},
			"GET/nest/polls/39c58f0f-28df-522d-9545-e759c928ba21": {
				id: "39c58f0f-28df-522d-9545-e759c928ba21",
				status: "pending",
				action: "Approve Contributions",
				payPeriodId: "payPeriodId",
				nextPollAt: "2021-09-01T00:00:00.000Z",
				expectedCompletionTime: "2021-09-01T00:00:00.000Z",
				payPeriodId: "ea4422cb-e260-43e4-b137-c593ba8f4386",
			},
			"GET/nest/import/pay-periods?pollId=8274157e-40a1-5d57-9796-7527a88979c2": {
				poll: {
					id: "8274157e-40a1-5d57-9796-7527a88979c2",
					status: "success",
					action: "Import Pay Periods",
					completedAt: "2021-09-01T00:00:00.000Z",
					expectedCompletionTime: "2021-09-01T00:00:00.000Z",
				},
				data: {},
			},
			"GET/nest/pay-period/49203824-7b15-43f6-bf08-9db4468daf04": {
				payPeriodId: "49203824-7b15-43f6-bf08-9db4468daf04",
				type: "NEST",
				org: "3a7a1324-e033-448c-96e6-d3a0c46dd6af",
				status: "success",
			},
			"GET/nest/pay-period/ceb82e86-119b-4ea4-8f4b-0ce031e4d448": {
				payPeriodId: "ceb82e86-119b-4ea4-8f4b-0ce031e4d448",
				type: "NEST",
				org: "3a7a1324-e033-448c-96e6-d3a0c46dd6af",
				status: "error",
			},
			"GET/nest/import/schemes?pollId=9a9cab95-ab95-58af-b525-df48dab294f4": {
				data: {},
				poll: {
					id: "9a9cab95-ab95-58af-b525-df48dab294f4",
					status: "success", // pending, response, success, error, timed out
					action: "Import Schemes & Groups",
					completedAt: "2021-09-01T00:00:00.000Z",
					schemes: [
						{
							name: "NEST Scheme",
							schemeType: "unbanded",
							startDate: "2021-09-01",
							endDate: "null",
						},
					],
					groups: [
						{
							name: "Group 1",
							startDate: "2021-09-01",
							endDate: "null",
							employeeContribution: 5,
							employeePercentage: true,
							employerContribution: 5,
							employerPercentage: true,
						},
						{
							name: "Directors",
							startDate: "2021-09-01",
							endDate: "null",
							employeeContribution: 0,
							employeePercentage: false,
							employerContribution: 1000,
							employerPercentage: false,
						},
					],
					expectedCompletionTime: "2021-09-01T00:00:00.000Z",
				},
			},
			"POST/nest/pay-period": {
				payPeriodId: "ceb82e86-119b-4ea4-8f4b-0ce031e4d448",
				type: "NEST",
				org: "3a7a1324-e033-448c-96e6-d3a0c46dd6af",
				status: "pending",
			},
		};

		// randomise the timeout duration between 300ms and 2500ms
		const timeout = Math.floor(Math.random() * 2200) + 300;

		setTimeout(() => {
			if (!mockObject[mock]) reject({ response: { data: { error: "No mock data found" } } });
			resolve({
				data: mockObject[mock],
			});
		}, timeout);
	});
};

const integrationRequest = createRequest({
	urlPath: "/integrations",
	// local: true,
});

const Types = {
	PENSION_INTEGRATION_UPDATE_CONNECTION: "PENSION_INTEGRATION_UPDATE_CONNECTION",
	PENSION_INTEGRATION_UPDATE_EMPLOYEE: "PENSION_INTEGRATION_UPDATE_EMPLOYEE",
	PENSION_INTEGRATION_UNSYNCED_EMPLOYEE: "PENSION_INTEGRATION_UNSYNCED_EMPLOYEE",
	PENSION_INTEGRATION_PENSION_STAGE: "PENSION_INTEGRATION_PENSION_STAGE",
	PENSION_INTEGRATION_SYNCING_STATUS: "PENSION_INTEGRATION_SYNCING_STATUS",
	PENSION_INTEGRATION_PAY_PERIOD: "PENSION_INTEGRATION_PAY_PERIOD",
	PENSION_INTEGRATION_COMPANIES: "PENSION_INTEGRATION_COMPANIES",
	PENSION_INTEGRATION_ACCOUNTS: "PENSION_INTEGRATION_ACCOUNTS",
	PENSION_INTEGRATION_SAVE: "PENSION_INTEGRATION_SAVE",
	PENSION_INTEGRATION_SAVING: "PENSION_INTEGRATION_SAVING",
	PENSION_INTEGRATION_UPDATE_FIELD: "PENSION_INTEGRATION_UPDATE_FIELD",
	PENSION_INTEGRATION_POLL_ACTION_MODAL: "PENSION_INTEGRATION_POLL_ACTION_MODAL",
	PENSION_INTEGRATION_SENDING_PAY_PERIOD: "PENSION_INTEGRATION_SENDING_PAY_PERIOD",
	PENSION_INTEGRATION_UPDATE_PAY_PERIOD: "PENSION_INTEGRATION_UPDATE_PAY_PERIOD",
	PENSION_INTEGRATION_PUSH_POLL_LIST: "PENSION_INTEGRATION_PUSH_POLL_LIST",
	PENSION_INTEGRATION_SET_POLL_LIST: "PENSION_INTEGRATION_SET_POLL_LIST",
};

const saveComplete = (integration, data) => ({
	type: Types.PENSION_INTEGRATION_SAVE,
	integration,
	data,
});

const saving = (integration) => ({
	type: Types.PENSION_INTEGRATION_SAVING,
	integration,
});

const updateField = (integration, field, value) => ({
	type: Types.PENSION_INTEGRATION_UPDATE_FIELD,
	integration: camelCase(integration),
	field,
	value,
});
const setPensionStage = (integration, stage) => ({
	type: Types.PENSION_INTEGRATION_PENSION_STAGE,
	integration,
	stage,
});
const connectPensionIntegration = (integration, credentials) => {
	return (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);

		integrationRequest({
			method: "GET",
			path: `/${integrationCamelCase}/new`,
		})
			.then(({ data }) => {
				if (!data.url) {
					NotificationManager.error(`Error Connecting ${integration}`, `Connect ${integration}`);
					return;
				}
				if (!data.url.startsWith("https://api.buddy.hr") && !data.url.startsWith("http://localhost")) {
					window.open(data.url, "_self");
				} else {
					const url = data.url.replace("https://api.buddy.hr/", "").replace("http://localhost:3001/", "");
					const [version, ...rest] = url.split("/");
					const reconstructedURL = rest.join("/").replace("integrations/", "");

					integrationRequest({
						method: "GET",
						path: `/${reconstructedURL}`,
						query: credentials,
					}).then((data) => {
						dispatch(INTEGRATION_ACTIONS.integrationGetList());
					});
				}
			})
			.catch((error) => {
				console.error(error);
				const body = error.response.data;
				NotificationManager.error(
					`Error Connecting ${integration}${body.error ? " - " + body.error : ""}`,
					`Connect ${integration}`,
				);
			});

		// if (true) {
		// 	// assumed oAuth 2.0 flow try to setup a new connection
		// 	window.open(apiURL + `/integrations/${integrationCamelCase}/new`, "_self");
		// } else {
		// 	// this starts a new connection (/connect is the callback url)
		// 	fetch(apiURL + `/integrations/${integrationCamelCase}/connect`, {
		// 		credentials: "include",
		// 		method: "GET",
		// 		headers: {
		// 			"Accept": "application/json",
		// 			"Content-Type": "application/json",
		// 		},
		// 	})
		// 		.then((response) => response.json())
		// 		.then((data) => {
		// 			window.open(data.url, "_blank");
		// 			dispatch(COMPANY_ACTIONS.getCompanySettings());
		// 		})
		// 		.catch((error) => {
		// 			console.error(error);
		// 			NotificationManager.error(`Error Connecting ${integration}`, `Connect ${integration}`);
		// 		});
		// }
	};
};

const verifyConnection = (integration) => {
	return (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);

		integrationRequest({
			method: "GET",
			path: `/${integrationCamelCase}/verify-connection`,
		})
			.then(({ data }) => {
				switch (data.status) {
					case "Pending":
						NotificationManager.info(
							`Connection With ${integration} Is Still Pending`,
							`Connect ${integration}`,
						);
						break;
					case "Connected":
						NotificationManager.success(`Successfully Connected ${integration}`, `Connect ${integration}`);
						dispatch(INTEGRATION_ACTIONS.integrationGetList());
						break;
					case "Error":
						NotificationManager.error(`Error Connecting ${integration}`, `Connect ${integration}`);
						break;
				}
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error(`Error Verifying Connection With ${integration}`, `Connect ${integration}`);
			});
	};
};

const disconnectPensionIntegration = (integration) => {
	return (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);

		integrationRequest({
			method: "DELETE",
			path: `/${integrationCamelCase}/`,
		})
			.then(() => {
				dispatch(INTEGRATION_ACTIONS.integrationGetList());
				NotificationManager.success(`Successfully Disconnected ${integration}`, `Disconnect ${integration}`);
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error(`Error Disconnecting ${integration}`, `Disconnect ${integration}`);
			});
	};
};

const sendingPayPeriod = (integration, periodId, status) => ({
	type: Types.PENSION_INTEGRATION_SENDING_PAY_PERIOD,
	integration,
	periodId,
	status,
});

const updatePayPeriod = (integration, period) => ({
	type: Types.PENSION_INTEGRATION_UPDATE_PAY_PERIOD,
	integration,
	period,
});

const pushPollToList = (integration, poll) => ({
	type: Types.PENSION_INTEGRATION_PUSH_POLL_LIST,
	integration,
	poll,
});

const setPollList = (integration, polls) => ({
	type: Types.PENSION_INTEGRATION_SET_POLL_LIST,
	integration,
	polls,
});

const sendPayPeriodToPensionIntegration = (integration, periodId) => {
	return async (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);

		const state = getState();
		const sending = state.integration?.pension?.[integrationCamelCase]?.sendingPayroll || [];

		if (sending.includes(periodId)) return;

		dispatch(sendingPayPeriod(integrationCamelCase, periodId, true));

		await integrationRequest({
			method: "POST",
			path: `/${integrationCamelCase}/pay-period`,
			body: { periodId },
		})
			.then(({ data }) => {
				if (data.arn){
					checkStepFunctionStatus(data.arn, (response) => {
						if (response.output) {
							try {
								const output = JSON.parse(response.output);
								dispatch(updatePayPeriod(integrationCamelCase, output.payPeriod));
								dispatch(sendingPayPeriod(integrationCamelCase, periodId));
							} catch (e) {
								console.log('error', e)
								NotificationManager.error(
									`Error Sending Pay Period to ${integration}`,
									`Send Pay Period to ${integration}`,
								);
							}
						}
					});
				} else {
					dispatch(updatePayPeriod(integrationCamelCase, data.payPeriod));
					dispatch(sendingPayPeriod(integrationCamelCase, periodId));
				}
			})
			.catch((error) => {
				let message;
				if (error.isAxiosError) {
					message = error.response?.data?.error;
				} else {
					console.error(error);
				}
				NotificationManager.error(
					message ? message : `Error Sending Pay Period to ${integration}`,
					`Send Pay Period to ${integration}`,
				);

				dispatch(sendingPayPeriod(integrationCamelCase, periodId));
			});

	};
};

const getSchemes = (integration, query = {}) => {
	return (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);

		integrationRequest({
			method: "GET",
			path: `/${integrationCamelCase}/import/schemes`,
			query,
		})
			.then(({ data }) => {
				if (data.arn){
					checkStepFunctionStatus(data.arn, (response) => {
						NotificationManager.success(`Successfully Imported Schemes & Groups`, `Import Schemes & Groups`);
					});
				}
				if (data.poll) {
					dispatch(pushPollToList(integrationCamelCase, data.poll));
				}
			})
			.catch((error) => {
				console.error(error);
				if (error?.response?.data?.poll) {
					dispatch(pushPollToList(integrationCamelCase, error.response.data.poll));
				}
				NotificationManager.error(`Error Getting Schemes & Groups`, `Get Schemes & Groups`);
			});
	};
};

const importSchemes = (integration, query = {}) => {
	return async (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);
		const isModalOpen = getState().integration.pension[integrationCamelCase].pollActionModal;

		integrationRequest({
			method: "GET",
			path: `/${integrationCamelCase}/import/schemes`,
			query,
		})
			.then(({ data }) => {
				if (data.arn){
					checkStepFunctionStatus(data.arn, (response) => {
						NotificationManager.success(`Successfully Imported Schemes & Groups`, `Import Schemes & Groups`);
					});
				}
				if (data.poll) {
					dispatch(pushPollToList(integrationCamelCase, data.poll));
				}
				if (data.data) {
					NotificationManager.success(`Successfully Imported Schemes & Groups`, `Import Schemes & Groups`);
					if (isModalOpen) dispatch(openPollActionModal(integrationCamelCase, false));
				}
			})
			.catch((error) => {
				console.error(error);
				if (error?.response?.data?.poll) {
					dispatch(pushPollToList(integrationCamelCase, error.response.data.poll));
				}
				NotificationManager.error(`Error Importing Schemes & Groups`, `Import Schemes & Groups`);
			});
	};
};

const importPayPeriods = (integration, query = {}) => {
	return async (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);
		const isModalOpen = getState().integration.pension[integrationCamelCase].pollActionModal;

		integrationRequest({
			method: "GET",
			path: `/${integrationCamelCase}/import/pay-periods`,
			query,
		})
			.then(({ data }) => {
				if (data.poll) {
					dispatch(pushPollToList(integrationCamelCase, data.poll));
				}
				if (data.data) {
					NotificationManager.success(`Successfully Pay Periods`, `Import Pay Periods`);
					if (isModalOpen) dispatch(openPollActionModal(integrationCamelCase, false));
				}
			})
			.catch((error) => {
				if (error?.response?.data?.poll) {
					dispatch(pushPollToList(integrationCamelCase, error.response.data.poll));
				}
				console.error(error);
				NotificationManager.error(`Error Importing Pay Periods`, `Import Pay Periods`);
			});
	};
};

const importEmployees = (integration, query = {}) => {
	return async (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);
		const isModalOpen = getState().integration.pension[integrationCamelCase].pollActionModal;

		integrationRequest({
			method: "GET",
			path: `/${integrationCamelCase}/import/employees`,
			query,
		})
			.then(({ data }) => {
				if (data.poll) {
					dispatch(pushPollToList(integrationCamelCase, data.poll));
				}
				if (data.data) {
					NotificationManager.success(`Successfully Imported Employees`, `Import Employees`);
					if (isModalOpen) dispatch(openPollActionModal(integrationCamelCase, false));
				}
			})
			.catch((error) => {
				console.error(error);
				if (error?.response?.data?.poll) {
					dispatch(pushPollToList(integrationCamelCase, error.response.data.poll));
				}
				NotificationManager.error(`Error Importing Employees`, `Import Employees`);
			});
	};
};

const syncEmployees = (integration) => {
	return async (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);

		integrationRequest({
			method: "GET",
			path: `/${integrationCamelCase}/sync/employees`,
		})
			.then(({ data }) => {
				if (data.poll) {
					dispatch(pushPollToList(integrationCamelCase, data.poll));
				}
			})
			.catch((error) => {
				console.error(error);
			});
	};
};

const checkPayrollStatus = (integration, payPeriodId) => {
	return async (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);

		integrationRequest({
			method: "GET",
			path: `/${integrationCamelCase}/pay-period/${payPeriodId}`,
		})
			.then(({ data }) => {
				switch (data.payPeriod?.status) {
					case "success":
						NotificationManager.success(
							`Successfully Sent Pay Period to ${integration}`,
							`Send Pay Period to ${integration}`,
						);
						break;
					case "error":
						NotificationManager.error(
							`Error Sending Pay Period to ${integration}`,
							`Send Pay Period to ${integration}`,
						);
						break;
				}
				dispatch(updatePayPeriod(integrationCamelCase, data?.payPeriod));
			})
			.catch((error) => {
				console.error(error);
			});
	};
};

const getOngoingPolls = (integration) => {
	return async (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);

		integrationRequest({
			method: "GET",
			path: `/${integrationCamelCase}/polls`,
		})
			.then(({ data }) => {
				dispatch(setPollList(integrationCamelCase, data));
			})
			.catch((error) => {
				console.error(error);
			});
	};
};

const checkPollStatus = (integration, pollId) => {
	return async (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);

		integrationRequest({
			method: "GET",
			path: `/${integrationCamelCase}/polls/${pollId}`,
		})
			.then(({ data }) => {
				if (data.status !== "pending") {
					dispatch(pushPollToList(integrationCamelCase, data));
					dispatch(handlePollAction({ integration, pollId, action: data.action, status: data.status }));
				}
				NotificationManager.success(`Successfully got poll status: ${toTitleCase(data.status)}`, "Poll Status");
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting Poll Status", "Poll Status");
			});
	};
};

const openPollActionModal = (integration, poll) => ({
	type: Types.PENSION_INTEGRATION_POLL_ACTION_MODAL,
	integration,
	poll,
});

const pollActionModal = (integration, pollId) => {
	return async (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);

		const onGoingPolls = getState().integration.pension[integrationCamelCase].onGoingPolls;
		const poll = onGoingPolls.find((poll) => poll.id === pollId);

		dispatch(openPollActionModal(integrationCamelCase, poll));
	};
};

const handlePollAction = ({ integration, pollId, action, status }) => {
	return async (dispatch, getState) => {
		const integrationCamelCase = camelCase(integration);
		const isModalOpen = getState().integration.pension[integrationCamelCase].pollActionModal;

		if (status === "pending") {
			dispatch(checkPollStatus(integration, pollId));
		} else if (isModalOpen && ["error", "response"].includes(status)) {
			switch (action) {
				case "Import Schemes & Groups":
					dispatch(importSchemes(integration, { pollId }));
					break;
				case "Import Employees":
					dispatch(importEmployees(integration, { pollId }));
					break;
				case "Import Pay Periods":
					dispatch(importPayPeriods(integration, { pollId }));
					break;
			}
		} else if (["error", "response"].includes(status)) {
			dispatch(pollActionModal(integration, pollId));
		}
	};
};

const save = (integration, data) => {
	return async (dispatch, getState) => {
		let state = getState();

		const integrationCamelCase = camelCase(integration);
		dispatch(saving(integration));

		fetch(apiURL + `/integrations/${integrationCamelCase}`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(cleanDeep(data)),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(saveComplete(integration, data));
			})
			.catch((error) => {
				console.error(error);
				dispatch(saveComplete(integration, {}));
				NotificationManager.error("Error Saving", `Unable to save your ${integration} settings`);
			});
	};
};

const Actions = {
	connectPensionIntegration,
	disconnectPensionIntegration,
	verifyConnection,
	setPensionStage,
	save,
	updateField,
	importSchemes,
	importEmployees,
	syncEmployees,
	checkPayrollStatus,
	getOngoingPolls,
	checkPollStatus,
	handlePollAction,
	pollActionModal,
	openPollActionModal,
	sendPayPeriodToPensionIntegration,
	getSchemes,
};

export { Actions, Types };
